/**
 * Release 33 (owner, 2026-11-02): after sign-in, on a device where SATU is not installed, the
 * shell shows on Beranda (the screen every sign-in opens; a screen scrolled to its step would
 * slide the band's button under the sticky header), in the calm band style of release 26, *Pasang SATU di perangkat ini agar
 * terbuka seperti aplikasi dan data tetap tersimpan.* With the browser's offer held, **Pasang**
 * opens its dialog; elsewhere **Lihat caranya** opens Akun › Pasang SATU at its steps. On iPhone,
 * iPad and Mac Safari one more line says why it matters there (the 7-day rule). **Tutup** is
 * remembered on the device; when and where the band shows is ../pasang/pita's.
 */
import { uiStrings } from '@satu/shared'
import { useState } from 'react'
import { Link } from 'react-router'
import { Button, buttonVariants } from '@/components/ui/button'
import { pitaPasangTampil, tandaiDitutup } from '../pasang/pita'
import {
  type LingkunganPasang,
  lingkunganPasangPeramban,
  pasangSekarang,
  useSituasiPasang,
} from '../pasang/tawaran'
import { Pita } from './PitaPindahAlamat'

const t = uiStrings.pasang

/** Where Lihat caranya goes: Akun, at its section (routes/akun/BagianPasang). */
export const TAUTAN_CARA_PASANG = '/akun#akun-pasang'

export function PitaPasang({ lingkungan }: { lingkungan?: LingkunganPasang }) {
  const [env] = useState(() => lingkungan ?? lingkunganPasangPeramban())
  const situasi = useSituasiPasang(env.fakta)
  const [selesai, setSelesai] = useState(false)
  const [sedang, setSedang] = useState(false)

  const tampil =
    !selesai &&
    pitaPasangTampil({
      situasi,
      hostname: env.hostname,
      storage: env.storage,
      sekarang: env.sekarang(),
    })
  if (!tampil) return null

  const tutup = () => {
    tandaiDitutup(env.storage, env.sekarang())
    setSelesai(true)
  }

  const pasang = async () => {
    if (sedang) return
    setSedang(true)
    const hasil = await pasangSekarang()
    setSedang(false)
    // Accepted: `appinstalled` follows. Dismissed: the person said no for now, as with Tutup.
    if (hasil === 'dibatalkan') tutup()
    else if (hasil === 'diterima') setSelesai(true)
  }

  const apple = situasi === 'ios' || situasi === 'mac-safari'
  return (
    <Pita nama="pasang">
      <div className="min-w-[16rem] flex-1">
        <p>{t.keterangan}</p>
        {apple ? <p className="text-muted">{t.tujuhHari}</p> : null}
      </div>
      <div className="flex flex-wrap items-center gap-x-3 gap-y-1">
        {situasi === 'prompt' ? (
          <Button variant="outline" onClick={() => void pasang()} aria-busy={sedang || undefined}>
            {t.pasang}
          </Button>
        ) : (
          <Link to={TAUTAN_CARA_PASANG} className={buttonVariants({ variant: 'outline' })}>
            {t.lihatCaranya}
          </Link>
        )}
        <Button variant="ghost" onClick={tutup}>
          {t.tutup}
        </Button>
      </div>
    </Pita>
  )
}
